import { computed, inject } from 'vue'
import CryptoJS from 'crypto-js'

export function useUserMenu() {
  const chave = inject('chaveSeguranca')
  let userData = null
  const encrypted = localStorage.getItem('loginNovoSanegeo')
  if (encrypted && chave) {
    const bytes = CryptoJS.AES.decrypt(encrypted, chave)
    userData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)).data.usuario
  }

  const iconMap = {
    'Atendimento / Solicitações': 'fas fa-headset',
    'Gestão de serviços e Equipes': 'fas fa-person-digging',
    'Módulos Complementares': 'fas fa-screwdriver-wrench',
    'Relatórios': 'fas fa-magnifying-glass-chart',
    'Configurações': 'fas fa-cogs',
    'Segurança': 'fas fa-shield-halved',
    'Manobras e Avisos': 'fas fa-grip',

    'Atendimento e Solicitações': 'fas fa-headset',
    'Gestão de Serviços e Equipes': 'fas fa-person-digging',
    'Relatórios, BI e DashBoard': 'fas fa-chart-bar',
    'Atividades Especiais': 'fas fa-star',
    'Gestão de Obras': 'fas fa-helmet-safety',
    'Gestão Manutenção Eletromecânica': 'fas fa-bolt',
    'Gestão Micro Medição': 'fas fa-gauge-high',
    'Cadastro Técnico GEO + WEB': 'fas fa-map-location-dot',
    'Telemetria de Grandes Clientes': 'fas fa-tower-broadcast',
    'Receita e Vendas Futuras': 'fas fa-hand-holding-dollar',
    'Gestão de Contas de Energia': 'fas fa-plug-circle-bolt',
    'Gestão da Pavimentação': 'fas fa-road',
    'Parâmetros Hidráulicos / Telemetria': 'fas fa-droplet',
    'Indicadores Técnicos IWA / Modelagem': 'fas fa-diagram-project',
    'Simulação Hidráulica': 'fas fa-sliders',
    'Gestão da Troca de Micromedidores': 'fas fa-gauge-high'
  }

  const filteredMenu = computed(() => {
    if (!userData?.modulos) return []
    const result = userData.modulos
      .filter(m => m.ativo && m.idModuloPai == null)
      .sort((a, b) => a.ordenacao - b.ordenacao)
      .map(m => ({
        title: m.descricao,
        // adiciona a URL do módulo para navegação direta
        value: m.urlControle,
        icon: iconMap[m.descricao] || 'fas fa-folder',
        children: m.telas
          .filter(t => t.ativo && t.permissoesUsuario?.length && t.exibirMenu)
          .sort((a, b) => a.ordenacao - b.ordenacao)
          .map(t => ({ title: t.descricao, value: t.url })),
        subModules: userData.modulos
          .filter(x => x.ativo && x.idModuloPai == m.id)
          .sort((a, b) => a.ordenacao - b.ordenacao)
          .map(x => ({
            title: x.descricao,
            // adiciona a URL do módulo para navegação direta
            value: x.urlControle,
            icon: iconMap[x.descricao] || 'fas fa-folder',
            children: x.telas
              .filter(t => t.ativo && t.permissoesUsuario?.length && t.exibirMenu)
              .sort((a, b) => a.ordenacao - b.ordenacao)
              .map(t => ({ title: t.descricao, value: t.url })),
          }))
      }))
    return result;
  })
  return { filteredMenu }
}
